'use strict';/* global define */define('modules/feedback/values/feedback-wizard-container-ids/index',['require','exports','module'],function(require,exports,module){'use strict';//                     ____
//                   .'* *.'
//                __/_*_*(_
//               / _______ \
//              _\_)/___\(_/_
//             / _((\- -/))_ \
//             \ \())(-)(()/ /
//              ' \(((()))/ '
//             / ' \)).))/ ' \
//            / _ \ - | - /_  \
//           (   ( .;''';. .'  )
//           _\"__ /    )\ __"/_
//             \/  \   ' /  \/
//              .'  '...' ' )
//               / /  |  \ \
//              / .   .   . \
//             /   .     .   \
//            /   /   |   \   \
//          .'   /    b    '.  '.
//      _.-'    /     Bb     '-. '-._
//  _.-'       |      BBb       '-.  '-.
// (________mrf\____.dBBBb.________)____)
//
// "Welcome to the feedback wizard container wizard"
// -> we gave the containers meaningful wizard names as ID's.
// ENJOY.
module.exports={supervisee:{prepare:'Etixius',approve:'Epramaprix'},supervisor:{prepare:'Fluwywras',finalize:'Otstrea'}};});
